import styled from '@emotion/styled';
import { Div } from '../../../layouts';
import { Config } from '../../../utils';

export const DayPriceEl = styled(Div)`
    &&& {
        height: 15px;
        display: block;
    }
    background-image: ${(props) => props.loading && `url(${Config.get('imgPath')}/onefront/prices/price_load_1x.gif)`}; 
    background-position: ${(props) => props.loading && `center`}; 
    background-repeat: ${(props) => props.loading && `no-repeat`};
    background-blend-mode: ${(props) => props.loading && `multiply`};
`;
